<template>
  <div>
    <div class="drafts oa-layout-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record.id)">
            修改
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.id)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },
  {
    title: '部门',
    dataIndex: 'organizationName',
    key: 'organizationName'
  },

  {
    title: '申请人',
    dataIndex: 'applypeople',
    key: 'applypeople',
    ellipsis: true
  },
  {
    title: '收款单位名称',
    dataIndex: 'payeename',
    key: 'payeename',
    ellipsis: true
  },
  {
    title: '合计金额(元)',
    dataIndex: 'famount',
    key: 'famount'
  },

  {
    title: '申请日期',
    dataIndex: 'applydata',
    key: 'applydata'
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]
import { PayMoneyDraftlist, delPayMoney } from './api/api'
export default {
  data() {
    return {
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      let params = {
        page: this.page,
        size: this.size
      }
      PayMoneyDraftlist(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delPayMoney({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(id) {
      if (id) {
        this.$router.push({
          path: '/FundPaymentDetial',
          query: {
            id
          }
        })
      } else {
        this.$router.push('/FundPaymentDetial')
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/FundPayment/drafts.vue